import React from "react";
import { CommonModal } from "../../AbstractElements";
import { Row, Col } from "reactstrap";
import { showAlert } from "../../Services/Shared.service";
import { deleteCorporateClient } from "../../Services/CorporateClient.service";
import { deleteCoupon, updateCoupon } from "../../Services/Coupons.service";

const EditCoupon = ({ Large, title, LargeModaltoggle, couponObj, fetchData, action }) => {
    const onSubmit = (formValues) => {
        let body = {...couponObj}
        if(action == "recover"){
            body["isDeleted"] = false
        }else if(action == "activate"){
            body["isActive"] = true
        }else if(action == "deactivate"){
            body["isActive"] = false
        }
        updateCoupon(body)
            .then(async (result) => {
                showAlert('success',`Coupon ${action} successfully`)
                await fetchData()
                LargeModaltoggle();
            })
            .catch((err) => {
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
    };
    return (
        <CommonModal
            isOpen={Large}
            title={action.charAt(0).toUpperCase() + action.slice(1)}
            toggler={LargeModaltoggle}
            size="md"
        >
            <Row className="driver-push-notification">
                <Col xl="12" className="push-botification-body">
                    <div className="text-center">Are you sure you want to {action} this coupon ?</div>
                </Col>
                <Col xl="12" className="push-notification-footer">
                    <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={() => onSubmit()}
                    >
                        Confirm
                    </button>
                </Col>
            </Row>
        </CommonModal>
    );
};

export default EditCoupon;
